import {Component, Input, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';

import {Ubicacion} from '../ubicacion/ubicacion';
import {Nodo} from '../nodo/nodo';
import {Gateway} from '../gateway/gateway';
import {TipoSensor} from '../tipoSensor/tipoSensor';
import {TipoBateria} from '../tipoBateria/tipoBateria';

import {NodoService} from './nodo.service';
import {GatewayService} from '../gateway/gateway.service';
import {TipoSensorService} from '../tipoSensor/tipoSensor.service';
import {TipoBateriaService} from '../tipoBateria/tipoBateria.service';
import {PermisoService} from '../permiso/permiso.service';
import {LoginService} from '../login/login.service';

declare var $: any;
import * as _ from "lodash";

@Component({
    selector: 'nodo',
    template: require('../../app/nodo/nodo.component.html'),
    styles: [require('../../app/nodo/nodo.component.css')]
})
export class NodoComponent implements OnChanges {

    @Input() ubicacion: Ubicacion;
    @Input() nodo: Nodo;
    active: any;
    deshabilitar: boolean;
    gateways: Gateway[];
    tiposSensores: TipoSensor[];
    tiposBaterias: TipoBateria[];
    @Output() permisos = new EventEmitter();
    usuario: any;

    constructor(private nodoService: NodoService,
                private gatewayService: GatewayService,
                private tipoSensorService: TipoSensorService,
                private tipoBateriaService: TipoBateriaService,
                private permisoService: PermisoService,
                private loginService: LoginService,) {
    }

    ngOnInit() {
        this.nodo = new Nodo();
        this.ubicacion = new Ubicacion();
        this.active = true;

        //Pedir permisos
        this.permisoService.getPermiso("nodo").subscribe(permisos => {
            var respuesta = new Map();
            for (let permiso of permisos.tipoPermiso) {
                respuesta.set(permiso.descripcion, true);
            }
            this.permisos.emit({permisos: respuesta});
        })

        this.usuario = this.loginService.getDecodeToken();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.ubicacion != undefined && this.ubicacion.sucursal_id != undefined)
            this.gatewayService.getGatewaysBySucursal(this.ubicacion.sucursal_id)
                .subscribe((gateways) => this.gateways = gateways);

        this.tipoSensorService.getTipoSensores()
            .subscribe((tipos) => this.tiposSensores = tipos);

        this.tipoBateriaService.getTipoBaterias()
            .subscribe((tipos) => this.tiposBaterias = tipos);

        if (this.nodo != undefined && this.nodo._id != undefined) {
            this.nodo.fechaAlta = this.nodo.fechaAlta.toString().slice(0, 10);
            this.nodo.fechaAltaBateria = this.nodo.fechaAltaBateria.toString().slice(0, 10);
        }
    }

    onBlurFrecuencia() {
        if (this.nodo.frecuenciaMedicion && !this.nodo.tiempoActividad)
            this.nodo.tiempoActividad = parseInt((this.nodo.frecuenciaMedicion as number * 2.2).toFixed(0));
    }

    closeModal() {
        //Reseteo formEmpresa para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Inicializo variables
        if (this.nodo._id != undefined && this.nodo._id != "" && this.nodo._id != null)
            this.nodoService.getNodo(this.nodo._id).subscribe((nodo) => {
                for (let nodoL of this.ubicacion.nodos) {
                    if (nodoL._id == nodo._id) {
                        nodoL.etiqueta = nodo.etiqueta;
                        nodoL.nombre = nodo.nombre;
                        nodoL.fechaAlta = nodo.fechaAlta;
                        nodoL.fechaAltaBateria = nodo.fechaAltaBateria;
                        nodoL.tiempoActividad = nodo.tiempoActividad;
                        nodoL.frecuenciaMedicion = nodo.frecuenciaMedicion;
                        nodoL.tipo_id = nodo.tipo_id;
                        nodoL.tipoBateria_id = nodo.tipoBateria_id;
                        nodoL.duracionEstimada = nodo.duracionEstimada;
                        nodoL.gateway_id = nodo.gateway_id;
                        break;
                    }
                }
            });
        //Seteo bandera para deshabilitar
        this.deshabilitar = false;
        //Ocultar modal
        $("#modalNodo").modal("hide");
        $("#confirmacionNodo").modal("hide");
    }

    eliminar() {
        if (this.nodo.borradoPermanente === true)
            this.nodoService.deleteStrict(this.nodo).subscribe(
                () => {
                    this.ubicacion.nodos = this.ubicacion.nodos.filter((nodoL) => nodoL._id !== this.nodo._id);
                    $("#confirmacionNodo").modal("hide");
                    this.nodo = new Nodo();
                });
        else
            this.nodoService
                .getNodo(this.nodo._id)
                .subscribe(nodo => {
                    this.nodoService.delete(nodo).subscribe(
                        (nodo) => {
                            for (let nodoL of this.ubicacion.nodos) {
                                if (nodoL._id == nodo._id) {
                                    nodoL.estado = nodo.estado;
                                    if (!nodo.estado)
                                        for (let sensor of nodoL.sensores_id) {
                                            sensor.estado = nodo.estado;
                                            for (let alarma of sensor.alarmas) {
                                                alarma.estado = nodo.estado;
                                                for (let aviso of alarma.avisosLista) {
                                                    aviso.estado = nodo.estado;
                                                }
                                            }
                                        }
                                    break;
                                }
                            }
                        });
                    $("#confirmacionNodo").modal("hide");
                    //setTimeout(function(){$('body').removeClass('modal-open');},4000);
                });
    }

    save() {
        var operacion = "";
        if (this.nodo._id == "" || this.nodo._id == undefined)
            operacion = "agregar";
        else
            operacion = "modificar";
        this.nodo.ubicacion_id = this.ubicacion;
        var nodoSimplificado = _.cloneDeep(this.nodo);
        delete nodoSimplificado.ubicacion_id.nodos;
        this.nodoService
            .save(nodoSimplificado)
            .subscribe((nodo) => {
                //Inicializo variables
                this.nodo = nodo;
                //Actualizo listas
                if (operacion == "agregar") {
                    if (this.ubicacion.nodos == undefined)
                        this.ubicacion.nodos = [];
                    this.ubicacion.nodos.push(nodo);
                } else {

                    for (let nodoL of this.ubicacion.nodos) {
                        if (nodoL._id == nodo._id) {
                            nodoL.etiqueta = nodo.etiqueta;
                            nodoL.nombre = nodo.nombre;
                            nodoL.fechaAlta = nodo.fechaAlta;
                            nodoL.fechaAltaBateria = nodo.fechaAltaBateria;
                            nodoL.tiempoActividad = nodo.tiempoActividad;
                            nodoL.frecuenciaMedicion = nodo.frecuenciaMedicion;
                            nodoL.tipo_id = nodo.tipo_id;
                            nodoL.gateway_id = nodo.gateway_id;
                            nodoL.tipoBateria_id = nodo.tipoBateria_id;
                            nodoL.duracionEstimada = nodo.duracionEstimada;
                            nodoL.repeatable = nodo.repeatable;
                            break;
                        }
                    }
                }
                this.nodo.fechaAlta = this.nodo.fechaAlta.toString().slice(0, 10);
                this.nodo.fechaAltaBateria = this.nodo.fechaAltaBateria.toString().slice(0, 10);
                //Ocultar modal
                $("#modalNodo").modal("hide");
                //Reseteo formEmpresa para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
            })
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/nodo/nodo.component.ts